export const css = {
    oneaction: '_1xm5JI8y',
    ' _key': 'apic-theme/apic/micro/quiz-widgets/flashcard'
};
export default css;
